export interface TUser {
  cat_id: number[];
  role: number;
  exp: number;
  fio: string;
  token: string;
  type: string;
  username: string;
  iat: number;
  id: number;
  rights?: { [x: number]: number };
}
export interface TUserState {
  readonly data: TUser | null;
  readonly loading: boolean;
  isAuth: boolean;
  readonly errors?: string | undefined;
}

export enum ActionTypes {
  GET_USER_R = '@@user/GET_USER_R',
  GET_USER_S = '@@user/GET_USER_S',
  GET_USER_E = '@@user/GET_USER_E',

  SET_IS_AUTH = '@@user/SET_IS_AUTH',
  SET_USER = '@@user/SET_USER',

  USER_CLEAN_UP = '@@user/USER_CLEAN_UP',
}
